export const FETCH_MAINTENANCES = 'FETCH_MAINTENANCES';
export const EDIT_MAINTENANCE = 'EDIT_MAINTENANCE';
export const DELETE_MAINTENANCE = 'DELETE_MAINTENANCE';
export const UPDATE_ACCUMULATED = 'UPDATE_ACCUMULATED';
